import { useState } from 'react'
import { Modal } from './Modal'
import { ActionButton, CheckList, Checkbox, FieldRow, Hint } from './styles'

// Cria ou edita um IDR do quadro. O IDR geral é um IDR com todos os circuitos do quadro marcados.
export function IdrModal({ idr, boardName, circuits, onSave, onClose }) {
  const [name, setName] = useState(idr?.name || '')
  const [selectedIds, setSelectedIds] = useState(
    () => new Set(idr ? circuits.filter((circuit) => circuit.idrId === idr.id).map((circuit) => circuit.id) : [])
  )

  const allSelected = circuits.length > 0 && selectedIds.size === circuits.length

  function toggle(circuitId) {
    setSelectedIds((previous) => {
      const next = new Set(previous)

      if (next.has(circuitId)) next.delete(circuitId)
      else next.add(circuitId)

      return next
    })
  }

  function describeCurrentIdr(circuit) {
    if (!circuit.idrId || circuit.idrId === idr?.id) return ''

    return selectedIds.has(circuit.id) ? `será movido de ${circuit.idrId}` : `hoje em ${circuit.idrId}`
  }

  return (
    <Modal
      title={idr ? `Editar IDR ${idr.id} - ${boardName}` : `Novo IDR - ${boardName}`}
      onClose={onClose}
      footer={
        <>
          <ActionButton type="button" $variant="secondary" onClick={onClose}>
            Cancelar
          </ActionButton>
          <ActionButton
            type="button"
            disabled={!name.trim()}
            onClick={() => onSave({ name: name.trim(), circuitIds: [...selectedIds] })}
          >
            {idr ? 'Salvar IDR' : 'Adicionar IDR'}
          </ActionButton>
        </>
      }
    >
      <FieldRow>
        <label>
          Nome
          <input
            type="text"
            maxLength={120}
            value={name}
            placeholder="Ex.: Tomadas das áreas molhadas"
            onChange={(event) => setName(event.target.value)}
          />
        </label>
      </FieldRow>

      <h3>Circuitos protegidos</h3>
      <Hint style={{ marginTop: 0 }}>
        Um circuito pertence a no máximo um IDR: marcar um circuito que já está em outro IDR o move para este. Para um
        IDR geral, selecione todos os circuitos do quadro.
      </Hint>

      {circuits.length === 0 ? (
        <p>Este quadro ainda não tem circuitos.</p>
      ) : (
        <>
          <ActionButton
            type="button"
            $variant="secondary"
            style={{ marginTop: 12 }}
            onClick={() => setSelectedIds(allSelected ? new Set() : new Set(circuits.map((circuit) => circuit.id)))}
          >
            {allSelected ? 'Desmarcar todos' : 'Selecionar todos (IDR geral)'}
          </ActionButton>
          <CheckList>
            {circuits.map((circuit) => (
              <label key={circuit.id}>
                <Checkbox checked={selectedIds.has(circuit.id)} onChange={() => toggle(circuit.id)} />
                <span>
                  {circuit.id} - {circuit.name || 'Sem nome'}
                </span>
                <small>{describeCurrentIdr(circuit)}</small>
              </label>
            ))}
          </CheckList>
        </>
      )}
      {selectedIds.size === 0 && <Hint>IDR sem circuitos vinculados não gera seleção de corrente no resultado.</Hint>}
    </Modal>
  )
}
